import { request, versionRequest } from '@/service/request';

// =============== OrgUnits Begin ===============

/** get org page list */
export function fetchGetOrgUnitsPageList(params?: Api.SystemManage.OrgUnitsSearchParams) {
  return request<Api.SystemManage.OrgUnitsPageList>({
    url: '/sys_org_units/page',
    method: 'GET',
    params
  });
}

/** add org info */
export function fetchAddOrgUnits(data: Api.SystemManage.OrgUnitsEdit) {
  return request<boolean>({
    url: '/sys_org_units/',
    method: 'POST',
    data
  });
}

/** get org info */
export function fetchGetOrgUnits(id: string) {
  return request<Api.SystemManage.OrgUnits>({
    url: `/sys_org_units/${id}`,
    method: 'GET'
  });
}

/** update org info */
export function fetchUpdateOrgUnits(data: Api.SystemManage.OrgUnitsEdit) {
  return request<boolean>({
    url: '/sys_org_units/',
    method: 'PUT',
    data
  });
}

/** edit delete org */
export function fetchDeleteOrgUnits(data: Api.Common.DeleteParams) {
  return request<boolean>({
    url: '/sys_org_units/',
    method: 'DELETE',
    data
  });
}

/** get org page tree */
export function fetchGetOrgUnitsTree() {
  return request<Api.SystemManage.OrgUnitsTree[]>({
    url: '/sys_org_units/tree',
    method: 'GET'
  });
}

export function fetchGetOrgUnitsByUserIdTree() {
  return request<Api.SystemManage.OrgUnitsTree[]>({
    url: '/sys_org_units/orgUnitsIdsTree',
    method: 'GET'
  });
}

/** get departments by org code */
export function fetchGetDepartmentsByOrgCode(orgCode: string) {
  return versionRequest<Api.SystemManage.OrgUnits[]>({
    url: `/sys_org_units/departments/${orgCode}`,
    method: 'GET'
  });
}

/** get users by org code */
export function fetchGetUsersByOrgCode(orgCode: string) {
  return request<Api.SystemManage.UserInfo[]>({
    url: `/sys_org_units/users/${orgCode}`,
    method: 'GET'
  });
}

/** get users by org code */
// export function fetchGetAllUsersByOrgCode(orgCode: string, params?: { pageNum?: number; pageSize?: number; realName?: string }) {
//   return request<Api.SystemManage.UserInfo[]>({
//     url: `/sys_org_units/all-users/${orgCode}`,
//     method: 'GET',
//     params
//   });
// }
export function fetchGetAllUsersByOrgCode(orgCode: string, params?: { pageNum?: number; pageSize?: number; realName?: string }) {
  return request<Api.SystemManage.UserInfo[]>({
    url: `/bestsign/ca-certificate/list`,
    method: 'GET',
    params
  });
}
export function fetchGetAllUsersByOrgCodes(orgCode: string, params?: { pageNum?: number; pageSize?: number; realName?: string }) {
  return request<Api.SystemManage.UserInfo[]>({
    url: `/sys_org_units/all-users/${orgCode}`,
    method: 'GET',
    params
  });
}

//
export function getBestSignAccount(orgBestSignAccount: any) {
  return versionRequest<any>({
    url: '/bestsign/getBestSignAccount/',
    method: 'GET',
    params: { unifiedCode: orgBestSignAccount }
  });
}

/** 根据组织编码查询其所有分子公司 */
export function fetchGetChildrenOrgUnits(orgCode: string) {
  return versionRequest<any[]>({
    url: '/sys_org_units/children',
    method: 'GET',
    params: { orgCode }
  });
}

// =============== OrgUnits End  ===============
